<div class="container user-info pt-16">
  <div class="text-center">
    @if (!loading && user && lang) {
      <div
        class="flex flex-col md:flex-row gap-6 justify-center items-center font-canelablack-primary text-4xl md:text-6xl"
        >
        <div
          class="h-32 w-32 cursor-pointer flex justify-center items-center rounded-full relative bg-mat-ef-revolution-primary-500 shadow-md"
        [ngClass]="{
          'p-[2px] ': !showAltIcon && user?.profilePictureUrl,
          'p-4': showAltIcon || !user?.profilePictureUrl
        }"
          (click)="openUserImgDetails()"
          >
          @if (!showAltIcon && user?.profilePictureUrl) {
            <img
              class="h-[124px] w-[124px] object-cover rounded-full shadow-md"
              [src]="user?.profilePictureUrl"
              (error)="showAltIcon = true"
              alt=""
              />
          }
          @if (showAltIcon || !user?.profilePictureUrl) {
            <div
              class="w-32 h-32 text-white flex items-center object-cover uppercase font-canelablack"
              >
              <span class="m-auto">{{ user | userinitials | async }}</span>
            </div>
          }
        </div>
        <div>
          {{ user | username | async }}
        </div>
      </div>
    }
    @if (loading && !user?.contactId) {
      <div class="id-skeleton">
        <ngx-skeleton-loader
          appearance="line"
          animation="progress"
        ></ngx-skeleton-loader>
      </div>
    }
  </div>
</div>
